import { motion } from "framer-motion";
import { Check, Instagram } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function ThankYou({ type, config }) {
  const { t } = useLang();
  const data = type === "owner" ? t.form.thanksOwner : type === "club" ? t.club.thanks : t.form.thanksTenant;
  const insta = config?.instagram || "https://instagram.com/hollandaemlak";

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ type: "spring", stiffness: 220, damping: 22 }}
      className="text-center py-10 px-4"
      data-testid="thank-you"
    >
      <div className="mx-auto h-16 w-16 rounded-full bg-moss/10 border border-moss/30 flex items-center justify-center">
        <Check size={30} strokeWidth={2.25} className="text-moss" />
      </div>
      <h3 className="mt-6 font-serif font-semibold text-3xl md:text-4xl tracking-tight">{data.title}</h3>
      <p className="mt-3 text-stone max-w-md mx-auto leading-relaxed">{data.body}</p>
      <p className="mt-2 text-sm text-ink font-semibold max-w-md mx-auto">{data.reminder}</p>
      <a
        href={insta}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="thankyou-instagram"
        className="mt-8 inline-flex items-center gap-2 h-14 px-7 rounded-xl bg-brand text-white text-base font-semibold hover:bg-brandhover shadow-md transition-colors"
      >
        <Instagram size={18} />
        {t.form.followInsta}
      </a>
    </motion.div>
  );
}
